import { STATUS } from "@/constants/statuses";
import BaseStore from "@/stateManagement/BaseStore";
import { IloomAttributesFiltersEntity } from "@apps/iloom_customization/reviews/entities/IloomAttributesFiltersEntity";
import { StoreConfig } from "@datorama/akita";
import { produce } from "immer";
import { singleton } from "tsyringe";

export interface IloomReviewsAttributesState {
    data: IloomAttributesFiltersEntity;
    status: STATUS;
}

const createInitialState = (): IloomReviewsAttributesState => ({
    data: {
        customerFilters: [],
        productFilters: [],
    },
    status: STATUS.VIRGIN,
});

@singleton()
@StoreConfig({ name: "IloomReviewsAttributesStore", producerFn: produce })
class IloomAttributesFiltersStore extends BaseStore<IloomReviewsAttributesState> {
    constructor() {
        super(createInitialState());
    }
}

export default IloomAttributesFiltersStore;
